import React from 'react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  helperText?: string;
  error?: string;
}

/**
 * Forwards ref so react-hook-form `register()` can attach to the native input.
 */
export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, helperText, error, className, ...rest }, ref) => {
    return (
      <label className="block text-sm">
        {label && <span className="mb-1 block text-xs text-textMuted">{label}</span>}
        <input
          ref={ref}
          className={[
            'w-full rounded-full border bg-surface px-4 py-2 text-sm text-text placeholder:text-textMuted/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary',
            error ? 'border-danger' : 'border-borderSoft',
            className
          ]
            .filter(Boolean)
            .join(' ')}
          {...rest}
        />
        {error ? (
          <span className="mt-1 block text-[11px] text-danger">{error}</span>
        ) : helperText ? (
          <span className="mt-1 block text-[11px] text-textMuted">{helperText}</span>
        ) : null}
      </label>
    );
  }
);

Input.displayName = 'Input';

